export enum UrlIncludes {
  OAUTH_TOKEN = '/oauth/token',
  OAUTH365_TOKEN = '/o365/oauth2',
  CONNDISCN = '/conndiscn',
  OAUTH_AUTHORIZE = '/authorize',
  MICROSOFT_ONLINE = 'microsoftonline.com',
  WELL_KNOWN = '.well_known',
  ON_MICROSOFT = 'onmicrosoft-com',
}